import ListFormHoc from "../../../../utils/listFormHoc";
import List from "./list";
import Form from "./form";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMainHeading } from "../../../../redux/modules/mainHeading/slice";

const ReportTemplates = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setMainHeading("Report Templates"));
  }, [dispatch]);

  return (
    <>
      <ListFormHoc List={List} Form={Form} module="imaging"></ListFormHoc>
    </>
  );
};

export default ReportTemplates;
